import { render, staticRenderFns } from "./run-form.vue?vue&type=template&id=8d4c2a9a&"
import script from "./run-form.vue?vue&type=script&lang=ts&"
export * from "./run-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports